const RETENTION_TYPES = Object.freeze({
  USER_PROFILES: 'user_profiles',
  PROFILE_AUDIT_LOGS: 'profile_audit_logs',
  CAMPAIGN_AUDIT_LOGS: 'campaign_audit_logs'
})

const TASK_STATUS_DONE = 2

const POLICY_LABEL_KEYS = Object.freeze({
  [RETENTION_TYPES.USER_PROFILES]: 'DataRetention_Overview_Type_UserProfiles',
  [RETENTION_TYPES.PROFILE_AUDIT_LOGS]:
    'DataRetention_Overview_Type_ProfileAuditLogs',
  [RETENTION_TYPES.CAMPAIGN_AUDIT_LOGS]:
    'DataRetention_Overview_Type_CampaignAuditLogs'
})

const HISTORY_IDENTIFIERS = Object.freeze({
  [RETENTION_TYPES.USER_PROFILES]: {
    live: 'cleanup_users',
    preview: 'cleanup_users_preview'
  },
  [RETENTION_TYPES.PROFILE_AUDIT_LOGS]: {
    live: 'audit_log_clean_up',
    preview: 'audit_log_clean_up_preview'
  },
  [RETENTION_TYPES.CAMPAIGN_AUDIT_LOGS]: {
    live: 'campaign_audit_log_clean_up',
    preview: 'campaign_audit_log_clean_up_preview'
  }
})

const CATEGORIES_BY_TYPE = Object.freeze({
  [RETENTION_TYPES.USER_PROFILES]: [
    {
      key: 'anonymous_profiles',
      i18n: 'DataRetention_Overview_Category_AnonymousProfiles',
      policyField: 'uncontactable_anonymous_profiles_retention_period'
    },
    {
      key: 'uncontactable_identified_profiles',
      i18n: 'DataRetention_Overview_Category_UncontactableProfiles',
      policyField: 'uncontactable_identified_profiles_retention_period'
    },
    {
      key: 'web_devices',
      i18n: 'DataRetention_Overview_Category_WebDevices',
      policyField: 'uncontactable_web_devices_retention_period'
    },
    {
      key: 'mobile_devices_ios',
      i18n: 'DataRetention_Overview_Category_IosDevices'
    },
    {
      key: 'mobile_devices_android',
      i18n: 'DataRetention_Overview_Category_AndroidDevices'
    }
  ],
  [RETENTION_TYPES.PROFILE_AUDIT_LOGS]: [
    {
      key: 'profile_audit_log_entries',
      i18n: 'DataRetention_Overview_Category_ProfileAuditLogEntries',
      policyField: 'profile_auditlog_retention_period_months'
    }
  ],
  [RETENTION_TYPES.CAMPAIGN_AUDIT_LOGS]: [
    {
      key: 'campaign_audit_log_entries',
      i18n: 'DataRetention_Overview_Category_CampaignAuditLogEntries',
      policyField: 'campaign_auditlog_retention_period_months'
    }
  ]
})

export {
  RETENTION_TYPES,
  TASK_STATUS_DONE,
  POLICY_LABEL_KEYS,
  HISTORY_IDENTIFIERS,
  CATEGORIES_BY_TYPE
}



// WEBPACK FOOTER //
// ./src/modules/settings/enum/DataRetentionEnums.js